/** @format */
import { useEffect, useState, useParams } from "react";
import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
// import "";
import {
    createCookieThatLastsForADay,
    getCookie,
    setCookie,
} from "./untils/helpers";
import mochiLogo from "./assets/images/logo_mochi.png";
import FirstScreen from "./component/FirstScreen";
import ScreenTypeCode from "./component/ScreenTypeCode";

function App() {
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        let params = new URLSearchParams(window.location.search);
        let userToken = params.get("token");
        if (userToken) {
            setIsLogin(true);
            createCookieThatLastsForADay("userToken", userToken);
        } else if (getCookie("userToken")) {
            setIsLogin(true);
        }
    }, []);

    return (
        <div className="wrapper">
            <div className="wrapper_app">
                <div className="app_header">
                    <div className="app_header_logo">
                        <img src={mochiLogo} alt="mochi logo" />
                    </div>
                </div>
                <div className="app_body">
                    {isLogin ? (
                        <ScreenTypeCode setIsLogin={setIsLogin} />
                    ) : (
                        <FirstScreen />
                    )}
                </div>
            </div>
        </div>
    );
}

export default App;
